// src/hooks/useKorapay.js
// Handles Korapay payment popup and verification

import { confirmMembershipPayment } from "../firebase/services";

const KORAPAY_PUBLIC_KEY = "pk_live_QbMo5zpim3vCmUT1yZFai8mDXqNPsiHTTenJfpho";
const MEMBERSHIP_AMOUNT  = 250; // ₦250

/**
 * Loads the Korapay inline script dynamically
 */
function loadKorapayScript() {
  return new Promise((resolve, reject) => {
    // Correct window object is window.Korapay
    if (window.Korapay) { 
      console.log("Korapay script already loaded");
      resolve(); 
      return; 
    }
    console.log("Loading Korapay script...");
    const script    = document.createElement("script");
    // Correct URL from docs
    script.src      = "https://korablobstorage.blob.core.windows.net/modal-bucket/korapay-collections.min.js";
    script.onload   = () => {
      console.log("Korapay script loaded successfully");
      resolve();
    };
    script.onerror  = () => {
      console.error("Failed to load Korapay script");
      reject(new Error("Failed to load Korapay script"));
    };
    document.body.appendChild(script);
  });
}

/**
 * Generate a unique payment reference
 */
function generateRef(uid) {
  const timestamp = Date.now();
  const random    = Math.random().toString(36).substring(2, 8).toUpperCase();
  return `RF-KORA-${uid.slice(0, 6).toUpperCase()}-${timestamp}-${random}`;
}

/**
 * Main Korapay payment function
 */
export async function initiateKorapayPayment({
  email, uid, name, phone = "",
  onSuccess, onClose, onError,
}) {
  try {
    // Load Korapay script
    await loadKorapayScript();

    // Use window.Korapay based on discovered docs
    if (!window.Korapay) {
      console.error("Korapay not found on window object");
      onError?.("Korapay could not be loaded. Please check your internet connection.");
      return;
    }

    if (!KORAPAY_PUBLIC_KEY) {
      console.error("KORAPAY_PUBLIC_KEY not configured");
      onError?.("Korapay public key is not configured.");
      return;
    }

    const txRef = generateRef(uid);
    console.log("Initializing Korapay with ref:", txRef);

    // Open Korapay popup using window.Korapay.initialize
    window.Korapay.initialize({
      key:       KORAPAY_PUBLIC_KEY,
      reference: txRef,
      amount:    MEMBERSHIP_AMOUNT,
      currency:  "NGN",
      customer: {
        email,
        name,
      },
      onSuccess: async (response) => {
        console.log("Korapay success response:", response);
        try {
          await confirmMembershipPayment(uid, response.reference || txRef);
          onSuccess?.(response);
        } catch (err) {
          console.error("Error confirming Korapay payment:", err);
          onError?.(
            `Payment received but activation failed. ` +
            `Please contact revolutionaryfoundation.org.ng@gmail.com with this reference: ${txRef}`
          );
        }
      },
      onClose: () => {
        console.log("Korapay popup closed");
        onClose?.();
      },
    });

  } catch (err) {
    console.error("Korapay error in initiateKorapayPayment:", err);
    onError?.("Payment initialization failed. Please check your connection and try again.");
  }
}
